import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import AuthGuard from './auth-guard';

export const ProtectedRouteLayout: FC = () => (
  <AuthGuard>
    <Outlet />
  </AuthGuard>
);
